"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TruncatableText = void 0;
var TruncatableText = function (originalText, maxLength) {
    var defaultMaxLength = 50;
    var text = getText();
    return isTruncated(text) ? text + '...' : originalText;
    function getText() {
        if (maxLength && originalText.length <= maxLength) {
            return originalText;
        }
        return originalText.substring(0, maxLength || defaultMaxLength);
    }
    function isTruncated(text) {
        return text !== originalText;
    }
};
exports.TruncatableText = TruncatableText;
//# sourceMappingURL=index.js.map